import { default as BORDER_RADIUSES } from './borderradiuses'
import { default as BORDER_WIDTHS } from './borderwidths'
import { default as BREAKPOINTS } from './breakpoints'
import { default as COLORS } from './colors'
import { default as ELEMENT_SIZES } from './elementsizes'
import { default as TRANSITIONS } from './transitions'
import { default as TYPOGRAPHYS } from './typographys'
import { default as Z_INDEXS } from './zindexs'

export default {
  BORDER_RADIUSES,
  BORDER_WIDTHS,
  BREAKPOINTS,
  COLORS,
  ELEMENT_SIZES,
  TRANSITIONS,
  TYPOGRAPHYS,
  Z_INDEXS,
}
